import React, { useState } from "react";

//import components
import DropdownSelect from "../../../assets/reusableComponents/dropDownSelect";

//functions for data fetching
import { useSelector, useDispatch } from "react-redux";
import { addHouses, getAllHouses } from "../../../../redux/slices/sliceActions";

//import resize function
import { vw, vh } from "../../../assets/reusableComponents/resizeFunction";

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
  modalContent: {
    backgroundColor: "white",
    padding: vh(20),
    borderRadius: vw(8),
    width: "90%",
    maxWidth: vh(500),
    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.3)",
    position: "relative",
    zIndex: 10000,
    animation: "fadeIn 0.3s ease",
    fontFamily: "Karla, sans-serif",
    overflowX: "hidden",
  },
  formGroup: {
    marginBottom: vh(15),
  },

  input: {
    width: "100%",
    padding: vh(10),
    marginBottom: vh(10),
    borderRadius: vw(5),
    border: "1px solid #ccc",
    fontSize: vh(16),
  },
  submitButton: {
    backgroundColor: "#192A3A",
    color: "white",
    padding: `${vh(10)} ${vh(20)}`,
    border: "none",
    borderRadius: vw(4),
    cursor: "pointer",
    fontSize: vh(16),
    marginTop: vh(10),
    width: "100%",
  },
  title: {
    fontSize: vh(24),
    marginBottom: vh(20),
    color: "#192A3A",
  },
};

const AddBulkHouses = ({ setShowAddBulkHousesModal, propertyId }) => {
  const dispatch = useDispatch();

  const [houseType, setHouseType] = useState("Bed Sitter");
  const [rentAmount, setRentAmount] = useState("");
  const [numberOfHouses, setNumberOfHouses] = useState("");

  const houseTypeChoices = [
    "Single Room",
    "Bed Sitter",
    "One Bedroom",
    "Two Bedroom",
    "Three Bedroom",
    "Office",
    "Shop",
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    const houseTypeMap = {
      "Single Room": "single",
      "Bed Sitter": "bed-sitter",
      "One Bedroom": "one-bedroom",
      "Two Bedroom": "two-bedroom",
      "Three Bedroom": "three-bedroom",
      Shop: "shop",
      Office: "office",
    };

    const houseData = {
      type: houseTypeMap[houseType],
      rent: parseFloat(rentAmount),
      numberOfHouses: parseInt(numberOfHouses, 10),
    };

    dispatch(
      addHouses({ housesDetails: houseData, propertyId: propertyId })
    ).then((res) => {
      if (res?.payload?.status === "success") {
        dispatch(getAllHouses({ id: propertyId }));
      }
    });

    setShowAddBulkHousesModal(false);
  };

  return (
    <div
      style={styles.overlay}
      onClick={() => setShowAddBulkHousesModal(false)}
    >
      <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h2 style={styles.title}>Add Bulk Houses</h2>
        <form onSubmit={handleSubmit}>
          <div style={styles.formGroup}>
            <label style={styles.label}>House Type</label>
            <DropdownSelect
              choices={houseTypeChoices}
              defaultChoice={houseType}
              onSelect={(choice) => setHouseType(choice)}
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label} htmlFor="rentAmount">
              Rent Amount
            </label>
            <input
              style={styles.input}
              type="number"
              id="rentAmount"
              placeholder="e.g. 5000"
              value={rentAmount}
              onChange={(e) => setRentAmount(e.target.value)}
              required
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label} htmlFor="numberOfHouses">
              Number of Houses
            </label>
            <input
              style={styles.input}
              type="number"
              id="numberOfHouses"
              placeholder="e.g. 5"
              value={numberOfHouses}
              onChange={(e) => setNumberOfHouses(e.target.value)}
              required
            />
          </div>
          <button style={styles.submitButton} type="submit">
            Add Houses
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddBulkHouses;
